/* global google */

import React, { useEffect } from "react";

const OptimizedRouteMap = ({ routes }) => {
  useEffect(() => {
    const initMap = () => {
      if (!routes || routes.length === 0) return;
      
      const mapElement = document.getElementById("google-optimized-map");
      if (!mapElement) return;

      const map = new google.maps.Map(mapElement, {
        zoom: 12,
        center: { lat: routes[0].stops[0].lat, lng: routes[0].stops[0].lng },
      });

      const bounds = new google.maps.LatLngBounds();
      const colors = ["#FF5733", "#33FF57", "#3357FF", "#FF33A1", "#A133FF"];

      routes.forEach((route, index) => {
        const color = colors[index % colors.length];

        // Draw Line
        new google.maps.Polyline({
          path: route.routePath,
          geodesic: true,
          strokeColor: color,
          strokeOpacity: 1.0,
          strokeWeight: 4,
          map: map,
        });

        // Draw Markers
        route.stops.forEach((stop, sIdx) => {
          const pos = { lat: stop.lat, lng: stop.lng };
          new google.maps.Marker({
            position: pos,
            map: map,
            label: { text: `${sIdx + 1}`, color: "white" },
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: color,
              fillOpacity: 1,
              strokeWeight: 2,
              strokeColor: "#FFFFFF",
            },
          });
          bounds.extend(pos);
        });
      });
      map.fitBounds(bounds);
    };

    if (window.google) {
      initMap();
    }
  }, [routes]);

  return <div id="google-optimized-map" style={{ width: "100%", height: "100%", borderRadius: "10px" }} />;
};

export default OptimizedRouteMap;